import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    height: props => props.fullHeight ? '100%' : 'auto',
    minHeight: props => props.minHeight || '300px',
  },
  spinner: {
    position: 'relative',
    width: props => props.size || '60px',
    height: props => props.size || '60px',
    '&:before': {
      content: '""',
      boxSizing: 'border-box',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      border: '4px solid transparent',
      borderTopColor: theme.palette.primary.main,
      borderBottomColor: theme.palette.primary.main,
      animation: '$spinner 1.2s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite',
    },
    '&:after': {
      content: '""',
      boxSizing: 'border-box',
      position: 'absolute',
      top: '10px',
      left: '10px',
      width: 'calc(100% - 20px)',
      height: 'calc(100% - 20px)',
      borderRadius: '50%',
      border: '3px solid transparent',
      borderLeftColor: theme.palette.primary.main,
      borderRightColor: theme.palette.primary.main,
      animation: '$spinner 0.8s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite reverse',
    },
  },
  '@keyframes spinner': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  loadingText: {
    marginTop: theme.spacing(3),
    opacity: 0.8,
    textAlign: 'center',
    maxWidth: '80%',
  },
}));

/**
 * @param {Object} props
 * @param {string} props.message
 * @param {string} props.size
 * @param {boolean} props.fullHeight
 * @param {string} props.minHeight
 * @param {JSX.Element} props.icon
 */
const LazyLoadingIndicator = ({
  message,
  size,
  fullHeight = false,
  minHeight,
  icon = null,
}) => {
  const classes = useStyles({ size, fullHeight, minHeight });

  return (
    <Box className={classes.root}>
      <div className={classes.spinner}></div>
      {message && (
        <Typography
          variant="body1"
          color="textSecondary"
          className={classes.loadingText}
        >
          {icon && <span style={{ marginRight: '8px', verticalAlign: 'middle' }}>{icon}</span>}
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LazyLoadingIndicator; 